var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExportData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ri:file-excel-2-line"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.38268 2.39933L12.8577 0.90266C12.9168 0.894179 12.977 0.898506 13.0343 0.915347C13.0916 0.932189 13.1447 0.96115 13.1898 1.00027C13.2349 1.03939 13.2711 1.08775 13.2959 1.14208C13.3207 1.19641 13.3335 1.25544 13.3335 1.31516V18.6877C13.3335 18.7473 13.3207 18.8062 13.2959 18.8605C13.2712 18.9148 13.2351 18.9631 13.1901 19.0022C13.145 19.0413 13.0921 19.0703 13.0349 19.0872C12.9777 19.1041 12.9176 19.1085 12.8585 19.1002L2.38185 17.6035C2.1832 17.5752 2.00143 17.4762 1.86992 17.3246C1.73842 17.1731 1.66602 16.9791 1.66602 16.7785V3.22433C1.66602 3.02367 1.73842 2.82975 1.86992 2.6782C2.00143 2.52664 2.18403 2.42762 2.38268 2.39933ZM3.33352 3.94683V16.0552L11.6668 17.2468V2.75516L3.33352 3.94683ZM14.1668 15.8343H16.6668V4.16766H14.1668V2.50099H17.5002C17.7212 2.50099 17.9332 2.58879 18.0894 2.74507C18.2457 2.90135 18.3335 3.11331 18.3335 3.33433V16.6677C18.3335 16.8887 18.2457 17.1006 18.0894 17.2569C17.9332 17.4132 17.7212 17.501 17.5002 17.501H14.1668V15.8343ZM8.50018 10.001L10.8335 13.3343H8.83352L7.50018 11.4293L6.16685 13.3343H4.16685L6.50018 10.001L4.16685 6.66766H6.16685L7.50018 8.57266L8.83352 6.66766H10.8335L8.50018 10.001Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportData);
export default __webpack_public_path__ + "static/media/exportData.a74ebb3d50a6bad28ac139d5cb228eb2.svg";
export { ForwardRef as ReactComponent };